// extracted by mini-css-extract-plugin
export default {"AddressBookEdit":"AddressBookEdit_AddressBookEdit__BF7PV"};